import { Component, OnInit, inject, signal } from '@angular/core';
import { AuthService } from './services/auth.service';
import { OauthService } from './services/oauth.service';
import { DOCUMENT, NgClass } from '@angular/common';
import { AuthenticationService } from './services/firebase/authentication.service';
import { AppCheck } from '@angular/fire/app-check';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDrawerContainer, MatDrawer, MatDrawerContent } from '@angular/material/sidenav';
import { VerticalMenuComponent } from './modules/template/components/vertical-menu/vertical-menu.component';
import { RouterOutlet } from '@angular/router';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [MatDrawerContainer, MatDrawer, VerticalMenuComponent, MatDrawerContent, NgClass, RouterOutlet]
})
export class AppComponent implements OnInit {
  auth = inject(AuthService);
  private _oauth = inject(OauthService);
  private appCheck = inject<AppCheck>('appCheck' as any);


  document = inject(DOCUMENT)
  matIconRegistry = inject(MatIconRegistry)
  domSanitizer = inject(DomSanitizer)
  authorize = inject(AuthenticationService)
  router = inject(Router)
  isAuth: boolean = undefined
  showMenu = signal<boolean>(true)

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {
    this.matIconRegistry.addSvgIcon(
      `gpt`,
      this.domSanitizer.bypassSecurityTrustResourceUrl(`./assets/icons/chatgpt.svg`)
    )

    this.matIconRegistry.addSvgIcon(
      `drag`,
      this.domSanitizer.bypassSecurityTrustResourceUrl(`./assets/icons/drag-icon.svg`)
    )
  }
  
  ngOnInit() {
    this._oauth.getToken()
    
    // Track route changes to hide menu on 2FA pages
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const is2FAPage = event.url === '/setup-2fa' || event.url === '/verify-otp';
        this.showMenu.set(!is2FAPage);
        // Add/remove class on body for CSS styling
        if (is2FAPage) {
          this.document.querySelector('body').classList.add('on-2fa-page');
        } else {
          this.document.querySelector('body').classList.remove('on-2fa-page');
        }
      });

    // Check initial route
    const currentUrl = this.router.url;
    const is2FAPage = currentUrl === '/setup-2fa' || currentUrl === '/verify-otp';
    this.showMenu.set(!is2FAPage);
    // Add/remove class on body for CSS styling
    if (is2FAPage) {
      this.document.querySelector('body').classList.add('on-2fa-page');
    } else {
      this.document.querySelector('body').classList.remove('on-2fa-page');
    }
    
    this.authorize.authState$.subscribe((response) => {
      this.isAuth = (response != null ? true : false)
      if(this.isAuth) {

        this.document.querySelector('body').classList.remove('is-animated')
        
        // Save user uid
        this.auth.user = response.uid
      } else {
        this.document.querySelector('body').classList.add('is-animated')
      }

    })
  }
}